/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {FeatureToggleContract} from './contracts/feature-toggle.contract';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleApi {
    private baseUrl = `/feature-toggles.json`;

    constructor(private http: HttpClient) {
    }

    getAllFeatureToggles(): Observable<FeatureToggleContract[]> {
        return this.http.get<FeatureToggleContract[]>(this.baseUrl);
    }
}
